<template lang="html">
<section class="login d-flex align-center" height="100%">
    <v-card class="pa-5 card" width="300">
        <v-card-title>התחברות</v-card-title>
        <v-alert v-if="error" type="error">{{error}}</v-alert>
        <v-form ref="form" v-model="valid">
            <v-text-field type="email" label="אימייל" v-model="form.email" append-icon="mdi mdi-email" :rules="requireRules" required></v-text-field>
            <v-text-field type="password" label="סיסמא" v-model="form.password" append-icon="mdi mdi-lock" :rules="requireRules" required></v-text-field>
            <v-btn color="primary" block @click="login">
                <v-icon left>mdi-key</v-icon>התחבר
            </v-btn>
        </v-form>
    </v-card>
</section>
</template>

<script lang="js">
import firebase from 'firebase/app'
export default {
    name: 'login',
    props: [],
    mounted() {

    },
    data() {
        return {
            valid: true,
            form: {},
            requireRules: [
                v => !!v || 'שדה חובה'
            ],
            error: null
        }
    },
    methods: {
        login() {
            let vue = this
            this.$refs.form.validate() &&
                firebase.auth().signInWithEmailAndPassword(this.form.email, this.form.password)
                .catch((error) => {
                    vue.error = error.message;
                });

        }
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
.login {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #099285;
}

.card {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>
